'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.createUniqueIDFactory = createUniqueIDFactory;
exports.createUniqueIndexFactory = createUniqueIndexFactory;

var isFunction = exports.isFunction = function (o) {
  return o && typeof o === 'function';
};

var isObject = exports.isObject = function (o) {
  return o && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
};

var isString = exports.isString = function (o) {
  return o && typeof o === 'string';
}; // Source
// https://github.com/Shopify/javascript-utilities/blob/master/src/other.ts


function createUniqueIDFactory() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = createUniqueIndexFactory(1);
  return function (prefixOverride) {
    return '' + (prefixOverride || prefix || '') + index();
  };
}

function createUniqueIndexFactory() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var index = typeof start === 'number' ? start : 1;
  return function () {
    return index++;
  };
}